export default "__VITE_ASSET__CnM8OOFW__"